const actions = {
  /**
   * Fetch the available consultations, getting from $http
   * and commit the data result.
   *
   * @param commit
   * @param $http
   * @param tag
   * @returns {Promise<void>}
   */
  async fetchAvailableConsultations({ commit, rootState: { $http } }, { tag }) {
    const { data } = await $http.get('/endpoints', { params: { tag } });

    const availableConsultations = data.map((consultation) => {
      consultation.value = parseFloat(consultation.value, 10);

      return consultation;
    });

    commit('setAvailableConsultations', availableConsultations);
  },

  /**
   * Create the consultation.
   *
   * @param $http
   * @param form
   * @param tag
   * @returns {Promise<void>}
   */
  async createQuery({ rootState: { $http } }, { form, tag }) {
    const rootFields = ['consultations', 'id', 'template'];

    const consultations = form.consultations.map((consultation) => consultation.name);
    const templateId = form.template ? form.template.id : null;
    const data = Object.keys(form)
      .filter((field) => !rootFields.includes(field))
      .reduce((dataFields, field) => {
        dataFields[field] = form[field];

        return dataFields;
      }, {});

    await $http.post('/query', {
      consultations,
      template_id: templateId,
      id: form.id,
      tag,
      data,
    });
  },

  /**
   * Fetch the groups list.
   *
   * @param commit
   * @param $http
   * @param tag
   * @param page
   * @returns {Promise<void>}
   */
  async fetchGroupsList({ commit, rootState: { $http } }, { page }) {
    const { data } = await $http.get('/query/group', { params: { page } });

    commit('setGroups', data);
  },

  async fetchBatchList({ commit, rootState: { $http } }, { page }) {
    const { data } = await $http.get('/query/batch', { params: { page } });

    commit('setGroups', data);
  },

  /**
   * Fetch the queries list from a group.
   *
   * @param commit
   * @param $http
   * @param id
   * @returns {Promise<void>}
   */
  async fetchGroupQueriesList({ commit, rootState: { $http } }, { id }) {
    const { data } = await $http.get(`/query/group/${id}`);

    commit('setQueriesInAGroup', { id, queries: data });
  },

  async fetchBatchQueriesList({ commit, rootState: { $http } }, { id }) {
    const { data } = await $http.get(`/query/batch/${id}`);

    commit('setBatchInAGroup', { id, data });
  },

  /**
   * Fetch the documents list.
   *
   * @param commit
   * @param $http
   * @returns {Promise<void>}
   */
  async fetchDocumentsList({ commit, rootState: { $http } }) {
    const { data } = await $http.get('/tag/others');

    commit('setDocuments', data);
  },

  async fetchAllTemplates({ commit, rootState: { $http } }, tag) {
    const { data } = await $http.get(`/template/all?tag=${tag}`);

    commit('setAvailableTemplates', data);
  },

  async requireBatchResultToEmail({ rootState: { $http } }, id) {
    await $http.get(`/batch/zip/${id}`);
  },
};

export default actions;
